import React from "react";
import { Rating } from "@mui/material";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import { StyledRatingSection } from "./kbRating.style";
import { handleKeyPress } from "utils/functions";

export interface IKBRating {
  rating: number;
  showMessage: boolean;
  handleChangeRating: (event: any) => void;
  locale: {
    thankYouForFeedback: string;
  };
}

const KBRating = (props: IKBRating) => {
  const { rating } = props;

  const handleChangeRating = (event: any) => {
    if (event.nativeEvent.clientX && event.nativeEvent.clientY) {
      props.handleChangeRating(event.target.value);
      event.target.blur();
    }
  };

  return (
    <StyledRatingSection>
      <Rating
        name="rating"
        className="rating"
        value={rating}
        emptyIcon={<StarBorderIcon fontSize="inherit" />}
        onChange={handleChangeRating}
        onKeyDown={(e: any) => handleKeyPress(e, 'Enter', () => props.handleChangeRating(e.target.value))}
      />
    </StyledRatingSection>
  );
};

KBRating.defaultProps = {
  rating: 1,
  showMessage: false,
  handleChangeRating: () => {},
  locale: {
    id: "f234a0dc-a0ea-11ec-b909-0242ac120002",
    thankYouForFeedback: "Thank you for your feedback.",
  },
};

export default KBRating;
